import { HttpService } from '@/services/http.service';

export default {
    async likePost(postId) {
        return await HttpService.httpPost(`/post-likes/create`, {'post_id':postId});
    },
}
